<template>
  <v-ons-page modifier="secondary">
    <v-ons-button
      modifier="light back"
      @click="backToTop"
    >
      TOPに戻る
    </v-ons-button>
    <div class="content">
      <ul class="link_list">
        <li
          v-for="(link, index) in linkList"
          :key="index"
          href="#"
          class="link_button"
        >
          <a
            href="#"
            @click="goToNext(link.page)"
          >
            {{ link.name }}
          </a>
        </li>
      </ul>
    </div>
  </v-ons-page>
</template>

<script>
import foodMenu from './food_menu.vue';

export default {
  data() {
    return {
      linkList: [
        {
          name: '食堂メニュー',
          page: foodMenu,
        },
      ],
    };
  },
  methods: {
    backToTop() {
      this.$store.commit('appNavigator/pop');
    },
    goToNext(page) {
      this.$store.commit('appNavigator/push', page);
    },
  },
};
</script>

<style scoped lang="scss">
.link_list {
  margin: 0 0 20px;
  padding: 0;
  width: 20em;
}
.link_button {
  display: block;

  a {
    display: inline-block;
    padding: 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?1bd643e8